import { ScreensTerms, UserProfile } from './types'
import client from '../../client'
import { ResponseSuccess } from '../../types'

export const getProfile = (token?: string) => {
  return client.get<ResponseSuccess<UserProfile>>('v1/users/me/profile', {
    headers: token
      ? { Authorization: `Bearer ${token}`, auth_sso: process.env.EXPO_PUBLIC_AUTH_SSO }
      : undefined
  })
}

export const updateProfile = async (
  params: Pick<UserProfile, 'profile_image_file_name' | 'phone_number_cell'>
) => await client.patch('v1/users/me', params)

export const getScreensTerms = () => client.get<ResponseSuccess<ScreensTerms>>(`/v1/screens`)

export const updateScreenTerms = async ({
  screen_id,
  accept
}: {
  screen_id: string
  accept: boolean
}) => await client.patch(`v1/screens/${screen_id}/${accept ? 'accept' : 'reject'}`)
